import React from "react";

interface PageItemProps {
  label: string;
  isActive?: boolean;
  isDisabled?: boolean;
  isEllipsis?: boolean;
  onPageChange: () => void | null;
}

export default function PageItem(
  { label, onPageChange, isActive = false, isDisabled = false, isEllipsis = false }: PageItemProps,
) {
  return (
    <li className={`page-item ${isActive ? "active" : ""} ${isDisabled ? "disabled" : ""}`}>
      <button className="page-link" onClick={onPageChange} disabled={isEllipsis}>
        {label}
      </button>
    </li>

  );
}
